import {changeIndex} from './harald-form-common'

$('#location-and-time-form').on('submit', (e) => {
  e.preventDefault();
  if(!$('#submit-location-and-time-form').hasClass('disabled')){
    setTimeAndInfoToLocalStorage();
    setTimeAndInfoSummary();
    hideProductsBasedOnSelectedCity();
    changeIndex(2);
  }
});

$('#customer_count').on('change', () => {
  checkSpace();
});

function hideProductsBasedOnSelectedCity() {
  let selectedCity = $('#city option:selected').text();

  $('.single-product').each(function() {
    let productId = $(this).data('id');

    let tama = $(this);

    $.ajax({
      // eslint-disable-next-line
      url: wpAjax.ajaxUrl,
      data: { action: 'harald_hide_products_based_on_city', productId, selectedCity },
      type: 'post',
      success: function(response) {
        let trimmedResponse = $.trim(response);
        
        if(trimmedResponse == false) {
          tama.css('display', 'none');
        }

      },
      error: function(err) {
        console.warn(err);
      },
      complete: function() {
        //$('#step-edit-date').removeClass('loading');
      },
    });
  });
}

export const checkSpace = () => {
  const c_max = $('#max-capacity').val();
  const c_count = $('#customer_count').val();
  //console.log(c_max);
  //console.log(c_count);
  //console.log(c_max < c_count);
  //console.log(parseInt(c_max) < parseInt(c_count));
  
  if(parseInt(c_max) < parseInt(c_count)) {
    $('#enquiry-message').removeClass('hidden');
    $('#reservation_time').addClass('hidden');
    $('#reservation_time').val($('#reservation_time option:first').val());

    if($('#enquiry-message').hasClass('hidden') && $('#reservation_time').val() && $('#reservation_time').val() != '') {
      $('#submit-edit-location-and-time-form').addClass('disabled');
    }
    else {
      
      if($('#reservation_date').val() != '') {
        $('.time-container').removeClass('disabled');
        $('#submit-edit-location-and-time-form').removeClass('disabled');
      }
    }
  } else {
    $('#enquiry-message').addClass('hidden');
    $('#reservation_time').removeClass('hidden');

    if(!$('#reservation_time').val()) {
      $('#submit-edit-location-and-time-form').addClass('disabled');
      $('#submit-location-and-time-form').addClass('disabled');
    }
  }
}

$('#reservation_time').on('change', () => {
  if($('#reservation_time').val() && $('#reservation_time').val() != ''){
    $('#submit-location-and-time-form').removeClass('disabled');
    $('#submit-edit-location-and-time-form').removeClass('disabled');
  }else {
    $('#submit-location-and-time-form').addClass('disabled');
    $('#submit-edit-location-and-time-form').addClass('disabled');
  }

  checkSpace();
});

$('#reservation_date').on('change', () => {
  checkSpace();
});

// $('#reservation_date').on('change', () => {
//   $('#submit-location-and-time-form').addClass('disabled');
//   $('#submit-edit-location-and-time-form').addClass('disabled');
// });

const setTimeAndInfoToLocalStorage = () => {
  let timeData = $('#location-and-time-form').serializeArray();

  if($('#enquiry-message').val()) {
    let customerTimeWish = $('#enquiry-message').val();
    let obj = {};
    obj['name'] = 'customer_time_wish';
    obj['value'] = customerTimeWish;
    timeData.push(obj);
  }

  window.localStorage.setItem('harald_time_and_location', JSON.stringify(timeData));
};

const setTimeAndInfoSummary = () => {
  const data = JSON.parse(window.localStorage.getItem('harald_time_and_location'));
  data.forEach(item => {
    if(item.name === 'city'){
      $('#summary-city').text($('#city option:selected').text());
      $('#summary-city-2').text($('#city option:selected').text());
    }
    if(item.name === 'reservation_date') {
      const timeArray = item.value.split('-');
      let timeString = timeArray[2] + '.' + timeArray[1] + '.' + timeArray[0];
      $('#summary-date').text(timeString);
      $('#summary-date-2').text(timeString);
    }
    if(item.name === 'reservation_time'){
      const d = new Date(item.value);
      $('#summary-time').text(d.toTimeString().split(' ')[0].substring(0,5));
      $('#summary-time-2').text(d.toTimeString().split(' ')[0].substring(0,5));
    }
    if(item.name === 'customer_count'){
      $('#summary-customer-count').text(item.value);
      $('#summary-customer-count-2').text(item.value);
    }
    if(item.name === 'customer_time_wish') {
      $('#summary-customer-time-wish').text(item.value);
      $('#summary-customer-time-wish-2').text(item.value);
    }
  });
};

export default {

}



// WEBPACK FOOTER //
// ./scripts/util/harald-form-step1.js